import { __assign } from "tslib";
import { connectMediaStore } from './withOwnReduxStore';
import { initMediaPopup } from '../actions';
import { normalizeDeviation, normalizeGallection, } from '../../redux/normalizr/helpers';
export default connectMediaStore(null, function (dispatch) { return ({
    initMediaPopup: function (payload) {
        var gallectionFolder = payload.gallectionFolder, tier = payload.tier;
        var entities;
        if (gallectionFolder) {
            entities = normalizeGallection(gallectionFolder);
        }
        else if (tier) {
            entities = normalizeDeviation(tier);
        }
        dispatch(initMediaPopup(__assign(__assign({}, payload), { entities: entities })));
    },
}); });
//# sourceMappingURL=withMediaPopupInit.js.map